import styled from 'styled-components';

export const BadgeBox = styled.div`
  position: relative;
`;

export const BadgeIcon = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 15px;
  width: 15px;
  background: ${({ theme }) => theme.palette.brand.main};
  border-radius: 25px;
  z-index: 1;
`;
